<template>
	<section class="view-pad-gallery">
		<section class="list" v-if="diagramCollection.length > 0">
			<figure
				v-bind:key="index"
				v-for="(diagramModel, index) in diagramCollection.models"
				v-html="diagramModel.getDiagram()"
				v-on:click="Handle_OnClickDiagram($event, diagramModel)"
			></figure>
		</section>

		<ViewUiStateNoDiagrams v-else-if="diagramCollection.uniqueKey" />

		<ViewUiStateLoader v-else />
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Pad
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewPadGallery extends ViewBase {
		/**
		 * @type ChalkySticks/Collection/Diagram
		 */
		@Prop({
			default: () =>
				ChalkySticks.Factory.Diagram.collection({
					limit: 24,
				}),
		})
		public diagramCollection!: ChalkySticks.Collection.Diagram;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param Event e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickDiagram(e: Event, diagramModel: ChalkySticks.Model.Diagram): Promise<void> {
			e.preventDefault();

			this.$router.push({
				name: 'PageExtrasPad',
				query: {
					pad: diagramModel.getHash(),
					tab: 'create',
				},
			});
		}

		// endregion: Event Handlers
	}
</script>
